import { APIRoute } from '@/modules/utils'
import { Address, AddressProvider } from '@/dataV3/Common/Address'
import { HydraCollection } from 'emt-library'

export const Route: APIRoute = {
  method: 'GET',
  path: `/v2/addresses/suggest`,
}

export type SearchParams = {
  input?: string
  latitude?: string
  longitude?: string
  strict?: boolean
}

export type SearchWithoutGeo = {
  input: string
  geolocation?: undefined
  strict?: boolean
}

export type SearchWithGeo = {
  input?: string
  geolocation: {
    latitude: string
    longitude: string
  }
  strict?: boolean
}

export type SearchAddressParams = SearchWithoutGeo | SearchWithGeo

export type SearchAddressResult<T extends SearchAddressParams> = T['geolocation'] extends undefined
  ? AddressProvider[]
  : Address[]

export type Response = HydraCollection<AddressProvider>
